import React, { useState } from 'react'
import PropTypes from 'prop-types'
import useMobile from 'ui/Datatable/mobile'

// Model
import Ecwt from 'models/Ecwt'

// Components
import Text from 'ui/Text'
import Button from 'ui/Button'
import IconAttachFile from 'ui/Icons/IconAttachedFile'

// Api
import { downloadDocument, downloadEcwt } from 'api/ecwt'

export const EcwtFileDownload = ({ ecwt }) => {
  const [downloadingDocument, setLoadingDocument] = useState(false)
  const [downloadingEcwt, setLoadingEcwt] = useState(false)
  const [downloadingAll, setLoadingAll] = useState(false)

  const isMobile = useMobile()

  const onDownloadEcwtDocument = async () => {
    try {
      setLoadingDocument(true)
      return await downloadDocument(ecwt.fileDownload)
    } catch ({ response }) {
      //
    } finally {
      setLoadingDocument(false)
    }
  }
  const onDownloadEcwt = async () => {
    try {
      setLoadingEcwt(true)
      return await downloadEcwt(ecwt.fileName)
    } catch ({ response }) {
      //
    } finally {
      setLoadingEcwt(false)
    }
  }
  const onDownloadAll = async () => {
    try {
      setLoadingAll(true)

      await Promise.all([
        downloadEcwt(ecwt.fileName),
        downloadDocument(ecwt.fileDownload),
      ])
    } catch ({ response }) {
      //
    } finally {
      setLoadingAll(false)
    }
  }
  return (
    <div>
      <div>
        <Text size={16} bold color="#000000" paddingTop={15} paddingBottom={5}>
          Supporting documents
        </Text>
        <div className="file" style={{ margin: '5px 0 15px', display: 'flex' }}>
          <IconAttachFile width="25" />
          <Button
            className="ml-2 text-left text-break"
            underline
            variant="link"
            disabled={ecwt.isVoid || !ecwt.isAcknowledge}
            size="sm"
            onClick={onDownloadEcwtDocument}
            loading={downloadingDocument}
          >
            {ecwt.fileDownload}
          </Button>
        </div>
      </div>

      <Button
        id="download-all-button"
        className={`${isMobile ? 'mr-1' : 'mr-3'} mt-3`}
        style={{ textAlign: 'left' }}
        disabled={ecwt.isVoid || !ecwt.isAcknowledge}
        loading={downloadingAll}
        onClick={onDownloadAll}
      >
        Download eCWT & all documents
      </Button>

      <Button
        id="download-ecwt-button"
        variant="outline-primary"
        className="mt-3"
        disabled={ecwt.isVoid || !ecwt.isAcknowledge}
        loading={downloadingEcwt}
        onClick={onDownloadEcwt}
      >
        Download eCWT only
      </Button>
    </div>
  )
}

EcwtFileDownload.propTypes = {
  ecwt: PropTypes.instanceOf(Ecwt),
}

EcwtFileDownload.defaultProps = {
  ecwt: new Ecwt(),
}

export default EcwtFileDownload
